import React from 'react'
import {Navbar} from '../Components/Navbar'
import {Footer} from '../Components/Footer'
export const SingleProduct = () => {
  return (
    <div>
      <Navbar/>
      <h1>SingleProduct</h1>
    <Footer/>
      </div>
  )
}
